export default __webpack_public_path__ + "static/media/kochany.876f2678.svg";